import { useCallback, useEffect, useRef } from 'react';
import { useBlocker } from 'react-router';

export const useWarnBeforeLeaving = (when = true, message = 'Are you sure you want to leave this page?'): void => {
  const blocker = useBlocker(when);
  const self = useRef(null);

  const handleWindowOrTabClose = useCallback(
    (e): string => {
      if (!when) return;
      e.returnValue = message;
      return message;
    },
    [when, message],
  );

  useEffect(() => {
    if (when) {
      blocker.proceed = () => {
        self.current = null;
      };
      blocker.reset = () => {
        self.current = null;
      };
      self.current = blocker;
    } else {
      self.current = null;
    }

    window.addEventListener('beforeunload', handleWindowOrTabClose);

    return () => {
      if (self.current) {
        self.current.reset();
        self.current = null;
      }
      window.removeEventListener('beforeunload', handleWindowOrTabClose);
    };
  }, [when, message, blocker, self, handleWindowOrTabClose]);
};
